import { FormComponentProps } from "antd/lib/form";
import { TTranslate } from "../../../service/locale/TranslationService";
import { ISystemParameter } from "../../../model/systemparameter/SystemParameter";
import React from "react";
import SystemParameterForm from "./SystemParameterForm";

export interface State {}

export interface UpdateSystemParameterFormProps extends FormComponentProps{
    translate: TTranslate;
    registerFormSubmitEventHandler: any;
    rowData: ISystemParameter;
}

class UpdateSystemParameterForm extends React.Component<UpdateSystemParameterFormProps, State>{
    componentDidMount(){
        const{registerFormSubmitEventHandler, rowData}=this.props;
        registerFormSubmitEventHandler(e=>{
            e.preventDefault();
            let updateSystemParameter;
            this.props.form.validateFields((err,values)=>{
                if (!err) {
                    updateSystemParameter = values;
                    updateSystemParameter.id=rowData.id
                  }
            });
            return updateSystemParameter;
        })
    }

render() {
    const { translate, rowData} = this.props;

    const {
      getFieldDecorator,
      getFieldValue
    } = this.props.form;

    return (
      <SystemParameterForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        rowData={rowData}
        getFieldValue={getFieldValue}
      />
    );
  }
}

export default UpdateSystemParameterForm;